import { render, staticRenderFns } from "./NewWQ.vue?vue&type=template&id=e54c8636&scoped=true&"
import script from "./NewWQ.vue?vue&type=script&lang=js&"
export * from "./NewWQ.vue?vue&type=script&lang=js&"
import style0 from "./NewWQ.vue?vue&type=style&index=0&id=e54c8636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54c8636",
  null
  
)

export default component.exports